export function AtWillDisclaimer({ text, className = "" }) {
  if (!text) return null;
  return (
    <div
      data-testid="at-will-disclaimer"
      className={`rounded-2xl border-l-4 border-terracotta-500 bg-cream-100 p-5 text-sm text-charcoal-soft ${className}`}
    >
      <p className="text-xs uppercase tracking-widest font-medium text-terracotta-500 mb-1">
        At-will disclaimer
      </p>
      <p className="whitespace-pre-wrap leading-relaxed">{text}</p>
    </div>
  );
}
